export const customMarkdownToHTML = (content: string | undefined | null): string => {
  if (!content) return '';

  return content
    .replace(/\*\*([\s\S]+?)\*\*(?!\*)/g, (_match: string, p1: string) => `<strong>${p1}</strong>`)
    .replace(/\*((?:\*\*|[\s\S])+?)\*(?!\*)/g, (_match: string, p1: string) => `<em>${p1}</em>`)
    .replace(/\+\+([\s\S]+?)\+\+(?!\+)/g, (_matcher: string, p1: string) => `<u>${p1}</u>`)
    .replace(
      /\[([^\]]+)\]\(([^\)]+)\)/g,
      (_matcher: string, p1: string, p2: string) => `<a href="${p2}">${p1}</a>`
    )
    .replace(/(%5C)([_+*`])(?!\2)/g, (_match: string, _p1: string, p2: string) => `\\${p2}`) // TODO: Decode`%5C` to `\` before some special characters (_+*`)
    .replace(/(\\)([_+*`])(?!\2)/g, (_match: string, _p1: string, p2: string) => p2); // TODO: Remove `\` before some special characters
};
